/* eslint-disable */
/**
 * Redirect the plural form of `accounts` to `account`
 * @export
 */
export const ACCOUNT_PLURAL_PAGE_REDIRECT = `/accounts/:accountId`;

/**
 * The path of the `AccountPage` to be consumed by a `<Router />`
 * @export
 */
export const ACCOUNT_PAGE_PATH = `/account/:accountId`;

/**
 * Create a `href` that will resolve to `AccountPage`
 * @export
 * @param {{ accountId: string }} params The dynamic params that need to be matched
 * @returns {string} The `ACCOUNT_PAGE_PATH`
 */
export const createAccountPageLink = ({ accountId }) => `/account/${accountId}`;

/**
 * Determine if the current page is the `AccountPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `AccountPage`
 */
export const isAccountPage = (match) => match.path === ACCOUNT_PAGE_PATH;
